module.exports = "/images/vendor/flag-icon-css/flags/4x3/td.svg?a0923ddc3c8abed20bfdfbd559c8d7b0";